import React from "react";
import { useLanguage } from "../../Translations/LenguageContext";

const NoDataFoundMex = ({message}) => {
    const {t} = useLanguage()
    return(
        <div className="no_org_cont fade-in">
            <p>{message}</p>
        </div>
    )
}


export default NoDataFoundMex